var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.preview
  }, [_c('base-icon', {
    directives: [{
      name: "p-t",
      rawName: "v-p-t",
      value: 4,
      expression: "4"
    }, {
      name: "color",
      rawName: "v-color:black-2",
      arg: "black-2"
    }],
    attrs: {
      "name": "security_safedeal"
    }
  })], 1), _c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 10,
      expression: "10"
    }],
    class: _vm.$style.title,
    domProps: {
      "textContent": _vm._s(_vm.$t('safe.deal.title'))
    }
  }), _c('div', {
    class: _vm.$style.description
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.displayStatus)) + " ")]), _c('div', {
    class: _vm.$style.info,
    on: {
      "click": _vm.handleClick
    }
  }, [_c('base-icon', {
    directives: [{
      name: "color",
      rawName: "v-color:violet",
      arg: "violet"
    }, {
      name: "cursor",
      rawName: "v-cursor",
      value: _vm.permission ? 'pointer' : 'default',
      expression: "permission ? 'pointer' : 'default'"
    }, {
      name: "opacity",
      rawName: "v-opacity",
      value: _vm.permission ? 1 : .5,
      expression: "permission ? 1 : .5"
    }],
    attrs: {
      "name": "notifications_question-circle"
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }